var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6566 7.79817L14.246 16.1257C14.1271 16.8276 13.5397 17.3394 12.8532 17.3394H7.14679C6.46026 17.3394 5.8729 16.8276 5.75401 16.1257L4.34343 7.79817",
    fill: "#CDCED6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02778 3.3211C8.59822 3.3211 8.25 3.68256 8.25 4.12844V4.93578H11.75V4.12844C11.75 3.68255 11.4018 3.3211 10.9722 3.3211H9.02778ZM13.0227 4.93578V4.12844C13.0227 2.95294 12.1047 2 10.9722 2H9.02778C7.89531 2 6.97727 2.95293 6.97727 4.12844V4.93578H3.63636C3.28491 4.93578 3 5.23152 3 5.59633C3 5.96114 3.28491 6.25688 3.63636 6.25688H16.3636C16.7151 6.25688 17 5.96114 17 5.59633C17 5.23152 16.7151 4.93578 16.3636 4.93578H13.0227ZM3.58542 7.13761H16.4146L14.8727 16.2401C14.7004 17.2578 13.8487 18 12.8532 18H7.14679C6.1513 18 5.29965 17.2578 5.12726 16.2401L3.58542 7.13761ZM5.10145 8.45872L6.38076 16.0113C6.44615 16.3974 6.76921 16.6789 7.14679 16.6789H12.8532C13.2308 16.6789 13.5538 16.3974 13.6192 16.0114L14.8985 8.45872H5.10145Z",
    fill: "#CDCED6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.a6dd41ecc2103457a20b6348702d4358.svg";
export { ForwardRef as ReactComponent };